import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PublicLayout from '@/components/PublicLayout';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FAQPage = () => {
  const [loading, setLoading] = useState(true);
  const [pageContent, setPageContent] = useState({ title: 'FAQ', content: '' });
  const [pageEnabled, setPageEnabled] = useState(true);

  useEffect(() => {
    fetchPageContent();
  }, []);

  const fetchPageContent = async () => {
    try {
      const [pageRes, settingsRes] = await Promise.all([
        axios.get(`${API}/pages/faq`),
        axios.get(`${API}/site-settings`)
      ]);
      
      setPageContent(pageRes.data);
      const isEnabled = settingsRes.data.pages_enabled?.faq !== false;
      setPageEnabled(isEnabled);
      
      if (!isEnabled) {
        toast.error('This page is currently unavailable');
      }
    } catch (error) {
      console.error('Failed to fetch page content');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <PublicLayout>
        <div className="flex items-center justify-center py-12">
          <p className="text-lg text-stone-600">Loading...</p>
        </div>
      </PublicLayout>
    );
  }

  if (!pageEnabled) {
    return (
      <PublicLayout>
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-stone-700 mb-2">Page Unavailable</h2>
            <p className="text-stone-600">This page is currently disabled.</p>
          </div>
        </div>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#1A4D2E] mb-8" style={{fontFamily: '"Playfair Display", serif'}}>
          {pageContent.title}
        </h1>
        
        <Card className="bg-white p-8 md:p-12 rounded-2xl card-shadow">
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-stone-700 leading-relaxed whitespace-pre-line">
              {pageContent.content}
            </p>
          </div>
        </Card>
      </div>
    </PublicLayout>
  );
};

export default FAQPage;
